import LocationGroupReleaseConcurrency from './LocationGroupReleaseConcurrency';
import LocationGroupReleaseMaxRetries from './LocationGroupReleaseMaxRetries';
import LocationGroupReleasePercentUpgrade from './LocationGroupReleasePercentUpgrade';
import LocationNumDevices from './LocationNumDevices';
import LocationNumDevicesUpgraded from './LocationNumDevicesUpgraded';
import LocationNumDevicesUpgrading from './LocationNumDevicesUpgrading';
import LocationNumStaleDevices from './LocationNumStaleDevices';
import LocationPctDevicesUpgraded from './LocationPctDevicesUpgraded';
export default function CreateFotaAttributes(molten, deviceType, blueprint) {
  molten.addPlugin('Attribute', LocationNumDevices({
    blueprint,
    deviceType
  }));
  molten.addPlugin('Attribute', LocationNumDevicesUpgraded({
    blueprint,
    deviceType
  }));
  molten.addPlugin('Attribute', LocationNumDevicesUpgrading({
    blueprint,
    deviceType
  }));
  molten.addPlugin('Attribute', LocationNumStaleDevices({
    blueprint,
    deviceType
  }));
  molten.addPlugin('Attribute', LocationPctDevicesUpgraded({
    blueprint,
    deviceType
  }));
  molten.addPlugin('Attribute', LocationGroupReleaseConcurrency({
    blueprint,
    deviceType
  }));
  molten.addPlugin('Attribute', LocationGroupReleaseMaxRetries({
    blueprint,
    deviceType
  }));
  molten.addPlugin('Attribute', LocationGroupReleasePercentUpgrade({
    blueprint,
    deviceType
  }));
}